import { Group, Stack } from '@mantine/core'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIntl } from 'react-intl'
import ShoppingList from '../../../components/purchase-fuel/shopping-cart/ShoppingList'
import { MadeService } from '../../../services/purchase-fuel/made/made.service'
import { ShoppingCartService } from '../../../services/purchase-fuel/shopping-cart/shoppingCart.service'
import swalAlert from '../../../utils/helpers/swalAlert'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
// import "./shoppingCart.scss"
import AppButton from '../../../component/common/AppButton.tsx'
import AppNumberInput from '../../../component/form/AppNumberInput.tsx'
import EntityDropdown from '../../../component/form/EntityDropdown.tsx'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppSimpleGrid from '../../../component/layout/AppSimpleGrid.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'
import { SuppliersService } from '../../../services/purchase-fuel/suppliers/suppliers.service'
import { purchaseFuels } from '../../../utils/constants/navlinks-Menu'

const ShoppingCart = () => {
  const { formatMessage: msg, formatDate } = useIntl()

  const { t } = useTranslation()

  // const [ ownStations, setOwnStations ] = useState()
  const [suppliers, setSuppliers] = useState()

  const [currentOwnStation, setCurrentOwnStation] = useState()
  const [currentG95, setCurrentG95] = useState()
  const [currentGOA, setCurrentGOA] = useState()
  const [currentGOAPLUS, setCurrentGOAPLUS] = useState()
  const [currentReplicateNum, setCurrentReplicateNum] = useState(1)

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'num',
    sortInit: 1,
    createAction: ShoppingCartService.create,
    otherCreateAction: ShoppingCartService.duplicate,
    getAll: ShoppingCartService.getAll,
    removeAction: ShoppingCartService.remove,
    removeAllAction: ShoppingCartService.removeAll, // TODO: indicar endpoint
    editAction: ShoppingCartService.update,
    rowsPerPageInitial: 100,
  })

  useEffect(() => {
    getSuppliers()
    // retrieveOwnstations()
  }, [])

  const clearShoppingCartBlock = () => {
    setCurrentOwnStation('')
    setCurrentG95('')
    setCurrentGOA('')
    setCurrentGOAPLUS('')
    setCurrentReplicateNum(1)
  }

  const createShoppingCartBlock = async () => {
    if (
      currentOwnStation &&
      (currentG95 || currentGOAPLUS || currentGOA) &&
      currentReplicateNum
    )
      ShoppingCartService.create({
        ownStationId: currentOwnStation,
        G95: currentG95 || undefined,
        GOA: currentGOA || undefined,
        GOAPLUS: currentGOAPLUS || undefined,
        replicateNum: currentReplicateNum || 1,
      }).then(() => {
        clearShoppingCartBlock()
        dataFacade.reload()
      })
  }

  // const retrieveOwnstations = async () => {
  //     const resp = await OwnFuelStationsService.getAll({ sort: "centerName"})
  //     const rows = resp?.resp?.map((item) => { return { value: item?._id, label: item?.centerName } })
  //     setOwnStations(rows)
  // }

  const getSuppliers = async () => {
    const resp = await SuppliersService.getAll({})
    if (resp) {
      setSuppliers(resp?.resp)
    }
  }

  const handleCreatePurchase = async () => {
    const confirm = await swalAlert.warning(
      msg({ id: 'swal.title.confirm.purchase' }),
      msg({ id: 'button.cancel' }),
      msg({ id: 'button.confirm' }),
    )
    if (confirm.isConfirmed) {
      const body = { list: dataFacade?.data?.resp }
      const resp = await MadeService.create(body)
      if (resp) {
        dataFacade.reload()
      }
    }
  }

  // Format date
  const proposalDate = formatDate(dataFacade?.data?.resp?.createdAt, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const data = (
    <Stack>
      <AppSimpleGrid cols={7}>
        <EntityDropdown
          entity="ownFuelStation"
          disabled={dataFacade?.loading}
          placeholder="ownStation"
          value={currentOwnStation}
          onChange={(option) => setCurrentOwnStation(option)}
          local={false}
          debounced={false}
        />
        <AppNumberInput
          value={currentGOA}
          onChange={(e) => setCurrentGOA(e)}
          placeholder={t('GOA')}
          local={false}
          debounced={false}
        />
        <AppNumberInput
          value={currentG95}
          onChange={(e) => setCurrentG95(e)}
          placeholder={t('G95')}
          local={false}
          debounced={false}
        />
        <AppNumberInput
          value={currentGOAPLUS}
          onChange={(e) => setCurrentGOAPLUS(e)}
          placeholder={t('GOAPLUS')}
          local={false}
          debounced={false}
        />
        <AppNumberInput
          value={currentReplicateNum}
          onChange={(e) => setCurrentReplicateNum(e)}
          placeholder={t('replicateNum')}
          local={false}
          debounced={false}
        />
        <AppButton
          breakpoint="xl"
          bg="primary"
          icon="play"
          label="blockAdd"
          onClick={createShoppingCartBlock}
          disabled={
            !currentOwnStation ||
            !currentReplicateNum ||
            (!currentG95 && !currentGOAPLUS && !currentGOA)
          }
        />
        <Group c="moure-orange">{proposalDate}</Group>
      </AppSimpleGrid>
      <Group w="100%" className="prososal">
        <ShoppingList
          dataFacade={dataFacade}
          suppliers={suppliers}
          pagerOptions={pagerOptions}
        />
      </Group>
    </Stack>
  )

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={purchaseFuels} breakpoint="xl" />}
      subheader={
        <AppToolbar
          rightSection={[
            <AppButton
              breakpoint="xl"
              icon="remove"
              label="button.emptyCart"
              onClick={dataFacade.removeAll}
            />,
            <AppButton
              breakpoint="xl"
              icon="add"
              bg="moure-orange"
              label="button.purchase.send"
              onClick={handleCreatePurchase}
            />,
          ]}
        />
      }
    >
      {data}
    </AppSection>
  )
}

export default ShoppingCart
